import { getExploreName } from "./platformCheck";

export const zoomConfig = {
  sdkKey: "xyTsEunWQb6-haU7boINgA",
  sdkSecret: "dhEYIcuocFiswdLgtvrCHgJzXLl5DMsjppr7",
  webEndpoint: "zoom.us",
  topic: "Your Session",
  name: `${getExploreName()}-${Math.floor(Math.random() * 1000)}`,
  password: "",
  signature: "",
  sessionKey: "",
  userIdentity: "",
  // role = 1 to join as host, 0 to join as attendee. The first user must join as host to start the session
  role: 1,
};

// Organization IDs that have access to special features (e.g., send invite, settings tab)
export const ORG_FEATURE_ACCESS_IDS = [
  "f914dd22-aa3d-4bce-a4e4-c17e0ed96f83",
  "ae500935-bce0-4d36-bd2d-ebdd460c8355",
  // Add more org UUIDs here as needed
];
